<template>
  <td :class="['prd-cell', {'prd-complete-cell': activity && activity.task_user_status_id == 3}]" @click="clickOnPeriod" @mouseover="toogleCloseBtn('fadeIn')" @mouseleave="toogleCloseBtn('fadeOut')">

    <b-button
      size="is-small"
      :class="['prd-complete-icon']"
      icon-right="check-bold"
      type="is-success" v-if="activity && activity.taskable && activity.taskable.effective"></b-button>
    <b-button
      v-if="activity"
      size="is-small"
      :class="['prd-delete-btn', 'animated', 'faster', deleteBtnClass]"
      type="is-danger"
      icon-right="close"
      @click.stop="confirmDialog"
      :loading="isClearLoading"></b-button>
    <p>{{taskName}}</p><p>
    <b>{{horseName}}</b></p>
  </td>
</template>

<script>
import TaskUserService from '@/services/TaskUserService'

export default {
  props: {
    period: {
      type: Object,
      required: true
    },
    activity: {
      type: Object,
      required: false,
      default: null
    },
    day: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      deleteBtnClass: '',
      isClearLoading: false
    }
  },
  methods: {
    clickOnPeriod () {
      this.$emit('clicked-period', {
        period: this.period,
        day: this.day,
        activity: this.activity
      })
    },
    confirmDialog () {
      let textTask = this.taskName ? `tarea <b>${this.taskName}</b>` : ''
      this.$buefy.dialog.confirm({
        title: 'Eliminar Tarea',
        message: `¿Está seguro que desea <b>eliminar</b> la tarea? <br> Asignada a <b>${this.horseName}</b> ${textTask}`,
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: this.clear
      })
    },
    async clear () {
      if (!this.activity) {
        return false
      }
      this.isClearLoading = true
      try {
        let response = await TaskUserService.deleteTaskUser(this.activity.id)
        if (response.status >= 200 && response.status < 300) {
          this.success('Se ha eliminado la tarea')
          this.$emit('clear-period')
        }
      } catch (error) {
        console.log(error)
        this.error()
      }
      this.isClearLoading = false
    },
    success (text) {
      this.$buefy.toast.open({
        message: text,
        type: 'is-success'
      })
    },
    error () {
      this.$buefy.toast.open({
        message: 'No se pudo realizar los cambios',
        type: 'is-danger'
      })
    },
    toogleCloseBtn (className) {
      this.deleteBtnClass = className
    }
  },
  computed: {
    taskName () {
      if (this.activity && this.activity.taskable) {
        return this.activity.taskable.name
      } else {
        return ''
      }
    },
    horseName () {
      if (this.activity) {
        return this.activity.horse.name
      } else {
        return ''
      }
    }
  },
  watch: {
    activity () {
      this.deleteBtnClass = ''
    }
  }
}
</script>

<style scoped>
  .prd-cell{
    position: relative;
  }
  .prd-cell:hover{
    background-color: rgba(224,224,224 ,0.7);
    cursor: pointer;

  }
  .prd-cell:hover  >  .prd-delete-btn{
    opacity: 1;
  }
  .prd-delete-btn{
    position: absolute;
    opacity: 0;
    top: 0px;
    right: 0px;
    border-radius: 0px;
    z-index: 0;
  }
  .prd-complete-icon{
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 0px;
    z-index: 0;
  }

  .prd-complete-icon:hover {
    background-color: rgb(35, 209, 96) !important;
  }

  .prd-complete-icon{
    line-height: 10px !important;
  }

  .prd-complete-cell{
    background-color: rgba(255,152,0,1) !important;
  }
</style>
